import { Controller } from "stimulus";
import Swiper from 'swiper/swiper-bundle';

export default class extends Controller {
  static targets = ["pagination", "nextButton", "prevButton"]

  connect() {
    this.swiper = new Swiper(this.element, {
      spaceBetween: 10,
      centeredSlides: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      loop: true,
      pagination: {
        el: '.' + this.paginationTarget.className,
        clickable: true,
      },
      navigation: {
        nextEl: '.' + this.nextButtonTarget.className,
        prevEl: '.' + this.prevButtonTarget.className,
      },
    })
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = undefined
    }
  }
}
